import React from "react";
import { withRouter } from 'react-router-dom';
import AppChat from "../app-chat/app-chat";
import PropTypes from "prop-types";
import $ from "jquery";
import "./page-projects-single-inbox.css";
import { ServiceProjects } from "../../services/service-projects";
import _ from "lodash";
import appState from "../../state/AppStateContainer";
import { ServiceUser } from '../../services/service-user';
import AppLayout from "../../components/layout/app-layout/app-layout";
import BackButton from "../../components/shared/BackButton/BackButton";
import { withTranslation } from "react-i18next";

class PageProjectsSingleInbox extends React.Component {
  state = {
    baseURL: "",
    dataLoaded: false,
    clients: [],
    currentSupplier: {},
    currentClient: {},
    totalFilesClient: [],
    totalFilesUser: [],
    messages: [],
    currentProject: { area: [] },
    getConversation: {
      conversation: []
    },
    adminUser: {},
    loading: true,
    unreadOnEntry: [],
  };
  key;
  appChat;

  // Props
  clients = [];
  currentSupplier = {};
  currentClient = {};
  totalFilesClient = [];
  totalFilesUser = [];
  messages = [];
  location;
  history;
  baseURL;

  async componentDidMount() {
    if ( !appState.state.token && (this.props.role || appState.getRoleFromUrlParams()) != "supplier") {
      this.props.history.push("/");
    }

    // Store current path to detect when leaving
    this.currentPath = this.props.location.pathname;
    
    // Listen for navigation to mark messages as read when leaving
    this.unlisten = this.props.history.listen((location) => {
      if (location.pathname !== this.currentPath) {
        if (this.state.unreadOnEntry?.length > 0) {
          const clearNotification = this.willHaveNoUnreadLeftAfterMarkRead(this.state.unreadOnEntry);
          this.markMessagesAsReadInBackend(this.state.unreadOnEntry, { clearNotification });
          this.setState({ unreadOnEntry: [] });
        }
      }
    });

    if (!_.isNull(this.props.currentProject)) {
      this.setState(
        {
          currentProject: this.props.currentProject,
          role: this.props.role || appState.getRoleFromUrlParams()
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({ clients: clients });
          await this.loadMessages();
        }
      );
    } else if (this.props.match.params.project) {
      const project = await this.getProjectBySlug(this.props.match.params.project);
      this.setState(
        {
          role: this.props.role || appState.getRoleFromUrlParams(),
          currentProject: project
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({ clients: clients });
          await this.loadMessages();
        }
      );
    }
    this.hasClickedSupplier = false;
  }

  componentWillUnmount() {
    if (this.state.unreadOnEntry?.length > 0) {
      const clearNotification = this.willHaveNoUnreadLeftAfterMarkRead(this.state.unreadOnEntry);
      this.markMessagesAsReadInBackend(this.state.unreadOnEntry, { clearNotification });
    }

    // Clean up history listener
    if (this.unlisten) {
      this.unlisten();
    }
  }

  fixOldBidFormLink = (msg, supMemberId) => {
    const oldLinkText = this.props.t('oldBidFormLinkText', 'Klicka här för att se inlämnat bud');
    if (msg.includes(oldLinkText)) {
      let parent = document.createElement('div');
      parent.innerHTML = msg;
      parent.querySelectorAll('a').forEach(aTag => {
        if(aTag?.href && !aTag.href.split(",")[1] && aTag.innerText === oldLinkText) {
          aTag.href = aTag.href+","+supMemberId;
        }
      });
      return parent.outerHTML;
    }
    return msg;
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    if (!appState.state.token && (nextProps.role || appState.getRoleFromUrlParams()) != "supplier") {
      this.props.history.push("/");
    }
    const newPathName = nextProps.location.pathname;
    const pathChanged = this.props.location.pathname !== newPathName;
    const projectIdChanged = this.props.currentProject?._id !== nextProps.currentProject?._id;

    if (pathChanged || projectIdChanged) {
      if (this.state.unreadOnEntry?.length > 0) {
        const clearNotification = this.willHaveNoUnreadLeftAfterMarkRead(this.state.unreadOnEntry);
        await this.markMessagesAsReadInBackend(this.state.unreadOnEntry, { clearNotification });
      }

      this.setState({ loading: true });
      const project = await this.getProjectBySlug(nextProps.match.params.project);
      this.setState(
        {
          role: nextProps.role || appState.getRoleFromUrlParams(),
          currentProject: project
        },
        async () => {
          this.props.checkRole(this.state.role);
          const clients = await this.getClients();
          this.setState({
            clients: clients
          });
          await this.loadMessages();
        }
      );
    }
  }

  async getProjectBySlug(slug) {
    if (appState.isSupplierRole()) {
      const supplier = await ServiceUser.getUserById(appState.state.token.id);
      return await ServiceProjects.getProjectBySlugForSupplier(
        slug,
        supplier.supplierId
      );
    }

    return await ServiceProjects.projectBySlug(slug)
  }

  getParams() {
    return this.props?.params ?? this.props?.match?.params;
  }

  getArea() {
    const { type } = this.getParams();
    let areaItem = [];
    const currentProject = this.state.currentProject;
    areaItem = currentProject.area.find(val => val.areaId && val.areaId.slug === type);
    this.setState({
      areaId: areaItem.areaId._id,
      areaName: areaItem.areaId.name,
    });
    return areaItem;
  }

  getSupplier() {
    const { supplier } = this.getParams();
    var area = this.getArea();
    var supplierItem = area.suppliers.filter(val => val.supplierId.slug == supplier);
    const currentSupplier = supplierItem[0] && supplierItem[0].supplierId;
    this.setState({ currentSupplier: currentSupplier });
    return currentSupplier;
  }

  async getClients() {
    var s = this.getSupplier();
    let clients = await ServiceProjects.getSupplierMembers(s._id, true);
    let clientsWithConversation = await ServiceProjects.getConversationMembers(
      this.state.currentProject._id,
      this.state.areaId,
      this.state.currentSupplier._id,
    );
    return clients
      .map(c => ({...c, hasConversation: !!clientsWithConversation.find(conv => conv._id == c._id)}))
      .filter(c => c.isActive || clientsWithConversation.find(conv => conv._id == c._id));
  }

  handleHistory() {
    this.clients = this.getClients();
    this.loadMessages();
  }

  async sortClients(clients) {
    clients = await this.getClients();
    var hasConversationArr = [];
    var restArr = [];
    clients.filter(val => {
      if (val.hasConversation) {
        hasConversationArr.push(val);
      } else {
        restArr.push(val);
      }
    });

    hasConversationArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    restArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    return [...hasConversationArr, ...restArr];
  }

  async loadMessages() {
    var locationURL = window.location.pathname;
    var client = locationURL;

    this.key = client;

    let clients = await this.sortClients();
    let currentClient = {};
    let basePath;
    if (this.props.supplierMemberId) {
      currentClient = clients.find(x => x._id === this.props.supplierMemberId);
    } else {
      if (this.props.match.params.supplierMember) {
        currentClient = clients.find(val => val.slug == this.props.match.params.supplierMember);
        let currentSupplierMenu = $(`[data-supplier-slug=${currentClient.slug}${this.state.areaId}]`);
        if (!this.hasClickedSupplier && currentSupplierMenu.length) {
          currentSupplierMenu[0].click();
          this.hasClickedSupplier = true;
        }
      } else {
        currentClient = { ...clients[0] };
        basePath = `${this.key}/${currentClient.slug}`;
        this.props.history.replace(basePath);
      }
    }

    const payload = {
      suppliermemberId: currentClient._id,
      projectId: this.state.currentProject._id,
      supplierId: this.state.currentSupplier._id,
      areaId: this.state.areaId
    };
    this.props.setCurrentData(payload);

    const getConversation = await ServiceProjects.getConversation(
      payload.supplierId,
      payload.projectId,
      payload.suppliermemberId,
      payload.areaId
    );


    let conversation = [];
    let totalFilesClient = [];
    let totalFilesUser = [];

    if (getConversation) {
      const isSupplierRole = appState.isSupplierRole();
      conversation = getConversation.conversation.map(x => {
        x.message = isSupplierRole ? this.fixOldBidFormLink(x.message, payload.suppliermemberId) : x.message;
        return ({
        _id: x._id,
        message: x.message,
        name: x.adminId ? x.adminId.name : x.supplierMemberId ? x.supplierMemberId.name : "",
        email: x.adminId ? x.adminId.email : x.supplierMemberId ? x.supplierMemberId.email : "",
        phone: x.adminId ? x.adminId.phone : x.supplierMemberId ? x.supplierMemberId.phone : "",
        type: x.adminId ? "user" : "client",
        date: x.createdAt,
        avatarUrl :x.adminId ? x.adminId.avatarUrl : "",
        files: x.attachment,
        isUnread: x.isUnread
      })
    });
      totalFilesClient = _.flatten(
        getConversation.conversation
          .filter(x => x.supplierMemberId)
          .map(x =>
            x.attachment.map(a => ({
              ...a,
              date: x.createdAt
            }))
          )
      );
      totalFilesUser = _.flatten(
        getConversation.conversation
          .filter(x => x.adminId)
          .map(x =>
            x.attachment.map(a => ({
              ...a,
              user: x.adminId,
              date: x.createdAt
            }))
          )
      );
    }

    // Get IDs of messages currently unread from backend
    const backendUnreadIds = conversation.filter(msg => msg.isUnread).map(msg => msg._id);
    
    // Show dots for messages that are currently unread from backend
    const messagesWithDots = conversation.map(msg => ({
      ...msg,
      showDot: msg.isUnread
    }));

    this.setState({
      adminUser: getConversation ? getConversation.adminId : {},
      clients,
      currentClient,
      messages: messagesWithDots,
      totalFilesUser,
      totalFilesClient,
      baseURL: basePath,
      loading: false,
      unreadOnEntry: backendUnreadIds,
    });
  }

  // True if after marking messageIds as read there will be no unread left in this conversation
  willHaveNoUnreadLeftAfterMarkRead = (messageIds) => {
    const remaining = this.getRemainingUnreadCountAfterMarkRead(messageIds);
    return remaining.length === 0;
  };

  getRemainingUnreadCountAfterMarkRead = (messageIds) => {
    const unreadNow = this.state.messages.filter(m => m.isUnread || m.showDot);
    const idsToMark = new Set((messageIds || []).map(id => String(id)));
    return unreadNow.filter(m => !idsToMark.has(String(m._id))).length;
  };

  markMessagesAsReadInBackend = async (messageIds, options = {}) => {
    if (messageIds.length === 0) return;

    const { clearNotification = true } = options;

    try {
      await Promise.all(
        messageIds.map(messageId =>
          ServiceProjects.markMessageRead({
            projectId: this.state.currentProject._id,
            supplierId: this.state.currentSupplier._id,
            supplierMemberId: this.state.currentClient._id,
            areaId: this.state.areaId,
            messageId
          })
        )
      );
      if (this.props.clearNotification) {
        this.props.clearNotification({
          supplierMemberId: this.state.currentClient._id,
          supplierId: this.state.currentSupplier._id,
          areaId: this.state.areaId,
          keepUnreadCount: this.getRemainingUnreadCountAfterMarkRead(messageIds)
        });
      }
      await appState.refreshProjectNotifications();
    } catch (error) {
      console.error('Failed to mark messages as read in backend:', error);
    }
  }

  getAllMemberNotifications = (supplierId) => {
    const { areaId } = this.state;
    const { currentProject } = this.props;
    let notification = [];

    const area = currentProject?.area?.find(ar => ar?.areaId?._id === areaId);

    if(area?.suppliers?.length) {
      const supplier = area.suppliers.find(s => s.supplierId._id === supplierId);
      const supNotifications = supplier?.supplierId?.notification;
      if (supNotifications) notification = supNotifications;
    }
    return notification;
  }

  goBack = async () => {
    if (this.state.unreadOnEntry?.length > 0) {
      const clearNotification = this.willHaveNoUnreadLeftAfterMarkRead(this.state.unreadOnEntry);
      await this.markMessagesAsReadInBackend(this.state.unreadOnEntry, { clearNotification });
      this.setState({ unreadOnEntry: [] });
    }
    const path = this.props.history.location.pathname.split('/').slice(0, 5).join('/');
    setTimeout(() => {
      this.props.history.push(path);
    }, 0);
  }

  handleMarkUnread = async (messageId) => {
    try {
      const wasAlreadyUnread = this.state.messages.some(
        msg => (msg._id === messageId || String(msg._id) === String(messageId)) && (msg.isUnread || msg.showDot)
      );

      await ServiceProjects.markMessageUnread({
        projectId: this.state.currentProject._id,
        supplierId: this.state.currentSupplier._id,
        supplierMemberId: this.state.currentClient._id,
        areaId: this.state.areaId,
        messageId
      });

      const idStr = String(messageId);
      this.setState(prevState => ({
        messages: prevState.messages.map(msg =>
          (msg._id === messageId || String(msg._id) === idStr) ? { ...msg, isUnread: true, showDot: true } : msg
        ),
        unreadOnEntry: prevState.unreadOnEntry.filter(id => String(id) !== idStr),
      }));

      if (!wasAlreadyUnread) {
        if (this.props.addNotification) {
          this.props.addNotification({
            supplierMemberId: this.state.currentClient._id,
            supplierId: this.state.currentSupplier._id,
            areaId: this.state.areaId
          });
        }
        await appState.refreshProjectNotifications();
      }
    } catch (error) {
      console.error('Failed to mark message as unread:', error);
    }
  }

  getNotificationsWithLocalCount = () => {
    const supplierId = this.state.currentSupplier?._id;
    const notifications = this.getAllMemberNotifications(supplierId) || [];
    const currentClientId = this.state.currentClient?._id;
    const { areaId } = this.state;
    
    if (!currentClientId) {
      return notifications;
    }

    const localUnreadCount = this.state.messages.filter(msg => msg.isUnread).length;

    const existingNotifIndex = notifications.findIndex(
      notif => notif.supplierMemberId === currentClientId
    );

    if (existingNotifIndex >= 0) {
      return notifications.map(notif => {
        if (notif.supplierMemberId === currentClientId) {
          return { ...notif, count: localUnreadCount };
        }
        return notif;
      });
    } else if (localUnreadCount > 0) {
      return [
        ...notifications,
        {
          supplierMemberId: currentClientId,
          areaId: areaId,
          count: localUnreadCount
        }
      ];
    }

    return notifications;
  }

  render() {
    const isBidForm = window.location.pathname.includes("/quotation/info");
    return (
      <AppLayout hideNavbar={isBidForm}
        title={
          <BackButton
            path={[this.state.currentProject?.name, this.state.areaName, this.state.currentSupplier?.name, this.props.t('button.back', 'Meddelanden')]}
            onClick={this.goBack}
          />}
      >
        <div className="page-projects-single-inbox">
          <AppChat
            adminUser={this.state.adminUser}
            role={this.state.role}
            areaId={this.state.areaId}
            ref={el => this.state.appChat}
            baseURL={this.state.baseURL}
            messages={this.state.messages}
            totalFilesClient={this.state.totalFilesClient}
            totalFilesUser={this.state.totalFilesUser}
            clients={this.state.clients}
            currentSupplier={this.state.currentSupplier}
            currentProjectId={this.state.currentProject._id}
            currentClient={this.state.currentClient}
            notification={this.getNotificationsWithLocalCount()}
            loading={this.state.loading}
            onMarkUnread={this.handleMarkUnread}
          />
        </div>
      </AppLayout>
    );
  }
}

export default withRouter(withTranslation('projects', { keyPrefix: 'singleProject.inbox' })(PageProjectsSingleInbox));
